<template>
  <van-icon name="warning-o" @click="showMsg" />
</template>

<script>
import {Dialog} from "vant";

export default {
  name: "question-mark",
  props:{
    msg: String
  },
  methods: {
    showMsg(){
      Dialog.alert({
        message: this.msg,
      })
    }
  }
}
</script>

<style scoped>
.tool-icon {
  font-size: 18px;
  width: 22px;
  height: 22px;
  color: #999;
  display: flex;
  align-items: center;
  justify-content: center;
  /*position: absolute;*/
  /*top: 50%;*/
  /*left: 80px;*/
}
</style>
